module.exports = __webpack_public_path__ + "img/36C8FA_176ACB_24A7EF_1D93EC-256px.ed0d4c31.png";